import { createContext, useContext, useMemo, useState } from 'react';

type HighlightedStopIdState = {
  highlightedStopId: number | undefined;
  setHighlightedStopId: (value: number | undefined) => void;
};

const initialHighlightedStopId: number | undefined = undefined;

export const HighlightedStopIdContext = createContext<HighlightedStopIdState>({
  highlightedStopId: initialHighlightedStopId,
  setHighlightedStopId: () => undefined,
});

export const useHighlightedStopIdContext = () => useContext(HighlightedStopIdContext);

export const HighlightedStopIdProvider = ({ children }: { children: React.ReactNode }) => {
  const [highlightedStopId, setHighlightedStopId] = useState<number | undefined>(initialHighlightedStopId);
  const state = useMemo(() => ({ highlightedStopId, setHighlightedStopId }), [highlightedStopId, setHighlightedStopId]);

  return <HighlightedStopIdContext.Provider value={state}>{children}</HighlightedStopIdContext.Provider>;
};
